import React from 'react';
import {
  formatVitalMetric,
  VITALS_EMPTY_STATE_TEXT,
} from 'core/vitals/utils';
import {
  VitalMetricHeader,
  VitalTrendChart,
} from 'core/vitals/TrendChart';
import {
  TrendChartPoint,
  VitalMetric,
} from 'core/vitals/types';

type VitalsTrendCardProps = {
  metric: VitalMetric;
  points: TrendChartPoint[];
};

export default function VitalsTrendCard({
  metric,
  points,
}: VitalsTrendCardProps) {
  const latestPoint = points.at(-1);
  return (
    <div
      className={`rounded-md border border-gray-200/80 bg-white p-4 shadow-[0_16px_40px_-28px_rgba(15,23,42,0.45)] ${metric.series.length > 1 ? 'md:col-span-2' : ''}`}
    >
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <VitalMetricHeader metric={metric} showUnit={false} />
        </div>
        {latestPoint && (
          <div className="text-2xl font-semibold leading-none text-gray-950 text-right">
            {formatVitalMetric(latestPoint, metric)}
            <span className="ml-1 text-sm font-medium text-gray-500">{metric.unit}</span>
          </div>
        )}
      </div>
      <div className="h-40 w-full">
        <VitalTrendChart
          metric={metric}
          points={points}
          axes
          compact
          fillArea={false}
          emptyText={VITALS_EMPTY_STATE_TEXT.noTrendDataForDateRange}
        />
      </div>
    </div>
  );
}
